import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col laptop:flex-row h-auto" }
const _hoisted_2 = { class: "w-full laptop:w-3/5 bg-blueDark py-7 px-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "pb-3 font-semibold text-greenLight" }, "Výroční zprávy spolku", -1)
const _hoisted_4 = { class: "flex flex-row flex-wrap justify-center text-greenLight" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full laptop:w-2/5 bg-gray-600 flex flex-row justify-center flex-wrap items-center gap-16 py-7 px-5 text-greenLight text-lg font-semibold\"><a class=\"hover:text-white transition duration-200 hover:scale-105\" href=\"https://www.rgform.eu/menu.php\" target=\"_blank\"><img src=\"/obrazky/odkazy/ksis.png\" alt=\"a\" class=\"w-[100px]\"></a><a class=\"hover:text-white transition duration-200 hover:scale-105\" href=\"https://www.csmg.cz/\" target=\"_blank\"><img src=\"/obrazky/odkazy/csmg.png\" alt=\"b\" class=\"w-[100px]\"></a><a class=\"hover:text-white transition duration-200 hover:scale-105\" href=\"https://csesg.cz/\" target=\"_blank\"><img src=\"/obrazky/odkazy/csesg.png\" alt=\"c\" class=\"w-[100px]\"></a></div>", 1)
const _hoisted_7 = { class: "bg-greenLight flex flex-col-reverse tablet:flex-row items-center py-10 gap-10 justify-between tablet:px-10 laptop:py-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/trasko_logo.svg",
  class: "h-[70px]"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col laptop:flex-row gap-5 laptop:mx-5 laptop:items-center\"><span class=\"font-semibold flex flex-row w-full justify-center laptop:w-auto\">Kontakty:</span><div class=\"flex flex-col gap-2\"><div class=\"flex text-left items-center px-5\"><span class=\"material-symbols-outlined px-3\">home</span><span>Drnovská 413/39a, Nosálovice, 682 01 Vyškov</span></div><div class=\"flex text-left px-5\"><span class=\"material-symbols-outlined px-3\"> mail </span><span>admin@sktrasko.cz</span></div></div></div>", 1)

import vyrocniZpravySpolku from "../../../public/data/vyrocniZpravySpolku";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vyrocniZpravySpolku), (zprava) => {
            return (_openBlock(), _createElementBlock("a", {
              href: '/PDFs/vyrocniZpravy/' + zprava.pdf,
              target: "_blank",
              key: zprava.year,
              class: "py-1 px-2 hover:underline hover:text-white transition duration-200"
            }, _toDisplayString(zprava.year), 9, _hoisted_5))
          }), 128))
        ])
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, {
        to: "/",
        class: ""
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _hoisted_9
    ])
  ], 64))
}
}

})